var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "div-block-102 noselect"
  }, [_c('div', {
    staticClass: "refinancing-amount-summary"
  }, [_c('span', [_vm._v("Suma refinancovaných úverov")]), _c('strong', [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.amounts.suma_refinancovanie)) + " EUR")]), _c('small', [_vm._v("Mení sa automaticky podľa úverov vybraných nižšie.")])]), _vm._l(_vm.refinancedDebtsGetter, function (debt, key) {
    return _c('div', {
      key: key,
      staticClass: "input-block contrast p-relative"
    }, [_c('div', {
      staticClass: "closebtn-broker-app pointer",
      on: {
        "click": function click($event) {
          return _vm.remove(debt);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f24_icons8-close.svg"
      }
    })]), _c('div', {
      staticClass: "closebtn-broker-app pointer edit",
      staticStyle: {
        "right": "20px"
      },
      on: {
        "click": function click($event) {
          return _vm.finishDebt(debt);
        }
      }
    }, [_c('img', {
      staticClass: "nav-link-icon extrasmall white",
      attrs: {
        "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/64cb50251cbbf5e263940bb6_edit%20icon%20simple.svg"
      }
    })]), _c('div', {
      staticClass: "div-block-101"
    }, [_c('div', [_vm._v(" " + _vm._s(_vm.translateDebtType(debt.typ)) + " "), _c('strong', [_vm._v(_vm._s(_vm.translateBank(debt.banka)))])]), _c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.debtBalance(debt))) + " EUR")])])]);
  }), _c('client-debt-handler', {
    attrs: {
      "type": 'refinancovane',
      "rules": ['priority'],
      "title": '+ refinancovaný úver'
    }
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }